module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Thin-9d76a80418615eb8f7d4294bcedd9578.woff2";